import CustomError from './CustomError'

export default class EntityDoesNotExistException extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
